module.exports = __webpack_public_path__ + "static/media/empire.c6b4ebcf.svg";